<template>
  <bb-upload :data="{file_ident:ident}"
             :action="parent.baseAPI"
             :accept="accept"
             upload-type="single"
             link
             :file-list="parent.ruleForm[keyString]"
             :on-remove="parent.removeSingleUpload"
             :on-success="parent.successSingleUpload"
             :before-upload="(file)=>{(this.CustomImageConfig ||customType.length>0)?imageUploadBefore(file,ident):parent.imageUploadBefore(file,ident)}"
             :key-string="keyString">
    <div slot="tip">
      <template v-if="imageConfig.width ==undefined&&imageConfig.height==undefined">
        {{`格式${imageConfig.type || '不限'}  规格不限 大小${imageConfig.size?`${imageConfig.size}KB以内`:'不限'}`}}
      </template>
      <template v-else>
        {{`格式${customType.length>0?customType.join('/'):imageConfig.type}  规格${imageConfig.width}*${imageConfig.height}  大小${imageConfig.size}KB以内`}}
      </template>
    </div>
  </bb-upload>
</template>

<script>
/* eslint-disable */
import BbUpload from "./BbUpload";
import {
  UPLOAD_API,
  CLIP_UPLOAD_API,
  imageVerification
} from "@/utils/common";
export default {
  components: {
    BbUpload
  },
  props: {
    ident:{
      type:String,
      required:true
    },
    accept:{
      type:String,
      default:"image/png"
    },
    keyString:{
      type:String,
      required:true
    },
    parent:{
      type:Object,
      required:true
    },
    CustomImageConfig:{
      type:Object,
      required:false
    },
    customType:{
        type:Array,
        required:false,
        default(){return []}
    }
  },
  // data() {
  //   return {
  //     imageConfig: this.$store.state.common.config
  //   };
  // },
  computed:{
    imageConfig(){
      if(this.CustomImageConfig){
        return this.CustomImageConfig
      }
      let temp = this.parent.imageConfig[this.ident]
      if(temp){
        return temp[0]
      }else{
        return {}
      }
    }
  },
  methods:{
    imageUploadBefore(file, ident) {

      console.log('自定义图片验证')
      // 产品
      const config = this.CustomImageConfig?[this.CustomImageConfig]:this.$store.state.common.config[ident];
      return imageVerification(
        this.parent,
        file,
        config,
        this.customType
      );
    },
  },
 

};
</script>

<style scoped>
</style>
